//const baseURL = "http://localhost/divine-server/public";
const baseURL = `${window.location.protocol}//divineblushbeauty.ca/divine-server/public`;
export default baseURL;